// Événements du tunnel commercial → analytics.js (compteur first-party + PostHog après consentement)
export const track = (event, props = {}) => {
  try {
    if (window.cpTrack) window.cpTrack(event, props);
  } catch (e) { /* noop */ }
};

export const posthogDistinctId = () => {
  try {
    return window.posthog && window.posthog.get_distinct_id ? window.posthog.get_distinct_id() : '';
  } catch (e) { return ''; }
};
